const settings = {
    gallery: {
      selector: '.pswp-gallery',
      itemSelector: '.pswp-gallery__item'
    }
  };
  
// Add lightboxOptions right after settings
const lightboxOptions = {
    gallery: settings.gallery.selector,
    children: 'a',
    pswpModule: PhotoSwipe,
    loop: true,
    padding: { top: 0, bottom: 0, left: 0, right: 0 },
    bgOpacity: 1,
    showHideOpacity: true,
    closeOnVerticalDrag: true,
    closeOnOutsideClick: true,
    zoom: {
      click: true,
      doubleClick: false,
      mouseWheel: true,
      maxRatio: 4
    },
    arrowPrev: true,
    arrowNext: true,
    counter: true,
    arrowKeys: true,
    wheelToZoom: true,
    imageClickAction: 'zoom',
    tapAction: 'zoom',
    scaleMode: 'fit'
  };


  let lightbox;
  let currentVariantImages = [];
  let variant_map = {};
  let variable_image_mapping = {};
  let photoswipeInitialized = false;
  let all_variants = window.productData.variants;
  const variant_count = window.productData.variantCount;
  const first_option = window.productData.firstOption;
  

  // Initialize variant mapping
  function initializeVariantMapping() {
    if (variant_count == 2) {
      // Two variants (usually Color and Size)
      for (let variant of all_variants) {
        let color = variant.option1;
        
        if (variant_map[color] === undefined) {
          variant_map[color] = [];
        }
        
        variant_map[color].push({
          'id': variant.id,
          'stock': variant.available,
          'name': variant.option2,
          'color': color,
          'image': variant.featured_image ? variant.featured_image.src : null
        });
      }
    } else {
      // Single variant - maintain array structure for consistency
      for (let variant of all_variants) {
        let option = variant.option1;
        
        if (variant_map[option] === undefined) {
          variant_map[option] = [];
        }
        
        variant_map[option].push({
          'id': variant.id,
          'stock': variant.available,
          'name': option,
          'color': option,
          'image': variant.featured_image ? variant.featured_image.src : null
        });
      }
    }
  }
  
  // Process metafield images
  // In processMetafieldImages function, add more detailed logging:
  function processMetafieldImages() {
    if (window.productData.metafieldImages) {
        // Preload main variant images first
        if (window.productData.variants) {
            let seenColors = new Set();
            window.productData.variants.forEach(variant => {
                if (!seenColors.has(variant.option1) && variant.featured_image) {
                    seenColors.add(variant.option1);
                    const preloadImage = new Image();
                    preloadImage.src = variant.featured_image.src;
                }
            });
        }

        console.log('Starting metafield processing with:', window.productData.metafieldImages);
      
        window.productData.metafieldImages.forEach(temp => {
            const imagePath = temp.path || '';
            const filename = imagePath.split("/").pop();
            const parts = filename.split("_");
            
            if (parts.length >= 3) {
                const productName = parts[0];
                // Join all middle parts and normalize the color name
                const filenameColor = parts.slice(1, -1).join(" ");
                const sequenceNum = parseInt(parts[parts.length - 1].split('.')[0]) + 1;

                // Get all available variant colors
                const variantColors = window.productData.variants.map(v => v.option1);
                
                // Find matching variant color by normalizing both strings
                const matchingColor = variantColors.find(variantColor => {
                    const normalizedVariant = variantColor.replace(/[\(\)\/]/g, " ").replace(/\s+/g, " ").trim();
                    const normalizedFile = filenameColor.replace(/[\(\)\/]/g, " ").replace(/\s+/g, " ").trim();
                    return normalizedVariant.toLowerCase() === normalizedFile.toLowerCase();
                });

                if (matchingColor) {
                    if (!variable_image_mapping[matchingColor]) {
                        variable_image_mapping[matchingColor] = [];
                    }

                    const mediaObj = {
                        src: temp.url,
                        type: temp.url.toLowerCase().includes('.mp4') ? 'video' : 'image',
                        sequenceNum: sequenceNum,
                        alt: `${matchingColor} image ${sequenceNum}`
                    };
                    
                    variable_image_mapping[matchingColor].push(mediaObj);
                } else {
                    console.warn(`No matching variant color found for filename color: ${filenameColor}`);
                }
            }
        });

        // Sort by sequence number
        Object.keys(variable_image_mapping).forEach(color => {
            variable_image_mapping[color].sort((a, b) => a.sequenceNum - b.sequenceNum);
        });

        console.log('Final complete variable_image_mapping:', variable_image_mapping);
    }
}

// Updated isVideoFile function
function isVideoFile(url) {
    if (!url) return false;
    
    const videoIndicators = [
        '.mp4',
        '.mov',
        '.webm',
        '/videos/',
        'video'
    ];
    
    const urlLower = url.toLowerCase();
    return videoIndicators.some(indicator => 
        urlLower.includes(indicator.toLowerCase())
    );
}
  
  // PhotoSwipe Initialization
  document.addEventListener('DOMContentLoaded', function() {
    initializeVariantMapping();
    processMetafieldImages();
    
    const checkPhotoSwipe = setInterval(() => {
      if (typeof PhotoSwipe !== 'undefined' && typeof PhotoSwipeLightbox !== 'undefined') {
        if (!photoswipeInitialized) {
          console.log('PhotoSwipe is now available, initializing...');
          photoswipeInitialized = true;
          clearInterval(checkPhotoSwipe);
          
          // Update the PhotoSwipe initialization in the DOMContentLoaded event listener
          lightbox = new PhotoSwipeLightbox({
            gallery: settings.gallery.selector,
            children: 'a',
            pswpModule: PhotoSwipe,
            loop: true,
            padding: { top: 0, bottom: 0, left: 0, right: 0 },
            bgOpacity: 1,
            showHideOpacity: true,
            closeOnVerticalDrag: true,
            closeOnOutsideClick: true,
            zoom: {
              click: true,
              doubleClick: false,
              mouseWheel: true,
              maxRatio: 3
            },
            arrowPrev: true,
            arrowNext: true,
            counter: true,
            arrowKeys: true,
            wheelToZoom: true // Add this
          });
          
  
          lightbox.init();
          
          document.querySelectorAll(settings.gallery.itemSelector).forEach((item, index) => {
            item.addEventListener('click', (e) => {
              e.preventDefault();
              lightbox.loadAndOpen(index);
            });
          });
        }
      }
    }, 100);
  });

  // Update variant selection
  function updateAddToCartButton(isAvailable, variantId) {
    const $button = $('#AddToCart');
    const $addText = $button.find('.add-to-cart-text');
    const $soldText = $button.find('.sold-out-text');
    const $priceInfo = $button.find('.button-price-info');
    const $stockInfo = $button.find('.button-stock-info');
    
    // Get full variant object if variantId is provided
    let variant = null;
    if (variantId && all_variants) {
      variant = all_variants.find(v => v.id === variantId || v.id === Number(variantId));
    }
    
    if (isAvailable && variant) {
      // Preserve existing background color (set by swatch color change handler)
      const existingBgColor = $button[0].style.backgroundColor;
      
      $button.removeClass('sold-out').prop('disabled', false);
      $addText.show();
      $soldText.hide();
      
      // Restore background color if it was set
      if (existingBgColor) {
        $button[0].style.backgroundColor = existingBgColor;
      }
      
      // Update pricing info
      const price = (variant.price / 100).toFixed(2);
      const comparePrice = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;
      
      let priceHtml = '';
      if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
        priceHtml = `<span class="button-compare-price">$${comparePrice}</span> <span class="button-current-price">$${price}</span>`;
      } else {
        priceHtml = `<span class="button-current-price">$${price}</span>`;
      }
      
      // Update button text with pricing inline
      $addText.html('Add to Cart - ' + priceHtml);
      
      // Show stock info
      $stockInfo.show();
      $priceInfo.hide(); // Price is now inline in add-to-cart-text
    } else if (isAvailable) {
      // Available but no variant info - just show basic button
      $button.removeClass('sold-out').prop('disabled', false);
      $addText.show().text('ADD TO CART');
      $soldText.hide();
      $priceInfo.hide();
      $stockInfo.hide();
    } else {
      $button.addClass('sold-out').prop('disabled', true);
      $addText.hide();
      $soldText.show();
      $priceInfo.hide();
      $stockInfo.hide();
    }
  }
  
  
  // Add this function to handle Klaviyo button positioning
    function initializeKlaviyoButton() {
    const $addToCartForm = $('#AddToCartForm');
    const $klaviyoTrigger = $('.klaviyo-bis-trigger');
    
    // If the trigger doesn't exist yet, create it
    if ($klaviyoTrigger.length === 0) {
      $addToCartForm.append(`
        <a class="klaviyo-bis-trigger button" 
           href="#" 
           style="display:none; margin-top: 10px; width: 100%;">
          Notify Me When Available
        </a>
      `);
    }
  }
  
  function updateVariantSelection() {
      if (variant_count == 2) {
        const selectedColor = $('input[name="option-0"]:checked').val();
        const selectedSize = $('input[name="option-1"]:checked').val();
        
        if (!selectedColor || !selectedSize) {
          console.log('Missing selection:', { color: selectedColor, size: selectedSize });
          updateAddToCartButton(false);
          return;
        }
        
        const variant = variant_map[selectedColor].find(v => v.name === selectedSize);
        if (!variant) {
          console.log('No valid variant found for selection');
          updateAddToCartButton(false);
          return;
        }
        
        $('#productSelect').val(variant.id);
        updateAddToCartButton(variant.stock, variant.id);
      } else {
        // Single variant handling
        if (first_option === 'Color') {
          const selectedValue = $('input[name="option-0"]:checked').val();
          if (!selectedValue) {
            console.log('No color selected');
            updateAddToCartButton(false);
            return;
          }
          
          const variant = all_variants.find(v => v.option1 === selectedValue);
          if (!variant) {
            console.log('Invalid variant');
            updateAddToCartButton(false);
            return;
          }
          
          $('#productSelect').val(variant.id);
          updateAddToCartButton(variant.available, variant.id);
        } else {
          // Size-only variant
          const selectedValue = $('input[name="option-1"]:checked').val();
          if (!selectedValue) {
            console.log('No size selected');
            updateAddToCartButton(false);
            return;
          }
          
          const variant = all_variants.find(v => v.option1 === selectedValue);
          if (!variant) {
            console.log('Invalid variant');
            updateAddToCartButton(false);
            return;
          }
          
          $('#productSelect').val(variant.id);
          updateAddToCartButton(variant.available, variant.id);
        }
      }
    
      // Update URL with selected variant
      // Remove this entire URL update block
      /* const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', $('#productSelect').val());
      window.history.replaceState({}, '', newUrl); */
  }
  
  // Initialize variant availability
  function initializeVariantAvailability() {
  if (variant_count == 2) {
    const selectedColor = $('input[name="option-0"]:checked').val();
    if (selectedColor && variant_map[selectedColor]) {
      variant_map[selectedColor].forEach(variant => {
        if (!variant.stock) {
          $(`.selector-element.size[data-value="${variant.name}"]`)
            .addClass('soldout')
            .removeClass('available')
            .find('.crossed-out').show();
        }
      });
    }
  } else {
    if (first_option === 'Size') {  
      all_variants.forEach(variant => {
        if (!variant.available) {
          $(`.selector-element.size[data-value="${variant.option1}"]`)
            .addClass('soldout')
            .removeClass('available')
            .find('.crossed-out').show();
        }
      });
    }
  }
  updateVariantSelection();
}
  
// Debug function
function debugVariantData() {
    console.log('window.productData:', window.productData);  // Add this line
    console.log('Product Options:', window.productData.options);
    console.log('All Variants:', all_variants);
    console.log('Variant Map:', variant_map);
    console.log('Current Selections:', {
      option0: $('input[name="option-0"]:checked').val(),
      option1: $('input[name="option-1"]:checked').val()
    });
}
  
  // Document ready handlers
  $(document).ready(function() {
    debugVariantData();

    // Initialize variants
    initializeVariantAvailability();
    console.log('Initializing variant availability...');

    // Check if a variant is pre-selected
    if (variant_count == 1 && first_option === 'Size') {
      // Single variant with only Size option - show ADD TO CART
      $('.add-to-cart-text').show().text('ADD TO CART');
      $('.sold-out-text').hide();
      $('#AddToCart').prop('disabled', false).removeClass('select-color');
  } else {
      // Multiple variants or Color option - check for color selection
      let selectedColor = $('input[name="option-0"]:checked').val();
      if (!selectedColor) {
          // Check for default color before showing default state
          const defaultColor = window.productData?.default_color;
          const defaultColorInput = $(`.swatch-element[data-value="${defaultColor}"] input`);
          
          if (defaultColor && defaultColorInput.length && !defaultColorInput.parent().hasClass('soldout')) {
              console.log('Selecting default color:', defaultColor);
                // Store current size labels before resetting
                $('.selector-element.size').each(function() {
                  const $label = $(this).find('label');
                  const labelText = $label.contents().first().text().trim();
                  $(this).data('size-label', labelText);
              });

              // Reset size selectors
              $('.selector-element.size .crossed-out').hide();
              $('.selector-element.size').removeClass('soldout').addClass('available');

              // Update size availability for default color
              if (variant_map[defaultColor]) {
                  variant_map[defaultColor].forEach(variant => {
                      if (!variant.stock) {
                          const $sizeElement = $(`.selector-element.size[data-value="${variant.name}"]`);
                          $sizeElement
                              .addClass('soldout')
                              .removeClass('available')
                              .find('.crossed-out').show();

                          // Restore the original label text
                          const labelText = $sizeElement.data('size-label');
                          if (labelText) {
                              $sizeElement.find('label').html(
                                  labelText + 
                                  '<img class="crossed-out" src="' + window.productData.assetUrl + '/soldout1.png" />'
                              );
                          }
                      }
                  });
              }

              defaultColorInput.prop('checked', true);
              updateVariantSelection();
              defaultColorInput.trigger('change');
          } else {
            const firstAvailableColor = $('.swatch-element:not(.soldout)').first();
            if (firstAvailableColor.length) {
                console.log('No default color, selecting first available:', firstAvailableColor.data('value'));
                
                // Store current size labels before resetting
                $('.selector-element.size').each(function() {
                    const $label = $(this).find('label');
                    const labelText = $label.contents().first().text().trim();
                    $(this).data('size-label', labelText);
                });
        
                // Reset size selectors
                $('.selector-element.size .crossed-out').hide();
                $('.selector-element.size').removeClass('soldout').addClass('available');
        
                // Update size availability for first available color
                const firstColor = firstAvailableColor.data('value');
                if (variant_map[firstColor]) {
                    variant_map[firstColor].forEach(variant => {
                        if (!variant.stock) {
                            const $sizeElement = $(`.selector-element.size[data-value="${variant.name}"]`);
                            $sizeElement
                                .addClass('soldout')
                                .removeClass('available')
                                .find('.crossed-out').show();
        
                            // Restore the original label text
                            const labelText = $sizeElement.data('size-label');
                            if (labelText) {
                                $sizeElement.find('label').html(
                                    labelText + 
                                    '<img class="crossed-out" src="' + window.productData.assetUrl + '/soldout1.png" />'
                                );
                            }
                        }
                    });
                }
        
                firstAvailableColor.find('input').prop('checked', true);
                updateVariantSelection();
                firstAvailableColor.find('input').trigger('change');
            } else {
                // If no colors are available, show sold out state
                $('.add-to-cart-text').hide();
                $('.sold-out-text').show();
                $('#AddToCart').prop('disabled', true);
            }
          }
      } else {
          // Color already selected, make sure variant is updated
          updateVariantSelection();
      }
  }

  // Event handlers for variant selection
  if (variant_count == 2) {
    // Color selection handler
    $('input[name="option-0"]').change(function() {
    // Store current size labels before resetting
    $('.selector-element.size').each(function() {
      const $label = $(this).find('label');
      const labelText = $label.contents().first().text().trim();
      $(this).data('size-label', labelText);
    });
    
  
    // Reset size selectors
    $('.selector-element.size .crossed-out').hide();
    $('.selector-element.size').removeClass('soldout').addClass('available');
  
    let selectedColor = $(this).val();
    console.log('Color selected:', selectedColor);
    updateImages(selectedColor);

    let isSoldOut = $(this).parent().hasClass('soldout');
    const $button = $('#AddToCart');
    $button.prop('disabled', false).removeClass('select-color');
    
    // Extract background color from selected swatch label
    const swatchElement = $(this).parent('.swatch-element');
    const selectedLabel = swatchElement.find('label')[0];
    let backgroundColor = null;
    
    if (selectedLabel) {
      // Try to get color from inline style first
      const inlineStyle = selectedLabel.getAttribute('style');
      if (inlineStyle && inlineStyle.includes('background-color')) {
        const match = inlineStyle.match(/background-color:\s*([^;]+)/);
        if (match) {
          backgroundColor = match[1].trim();
        }
      }
      
      // Fallback to computed style if no inline style
      if (!backgroundColor) {
        const computedStyle = window.getComputedStyle(selectedLabel);
        backgroundColor = computedStyle.backgroundColor;
        if (backgroundColor === 'rgba(0, 0, 0, 0)' || backgroundColor === 'transparent' || backgroundColor === 'rgb(0, 0, 0)') {
          backgroundColor = null;
        }
      }
    }
    
    // Apply background color to button if available
    if (backgroundColor && !isSoldOut) {
      $button[0].style.backgroundColor = backgroundColor;
      
      // Calculate text color based on luminance
      const tempDiv = document.createElement('div');
      tempDiv.style.backgroundColor = backgroundColor;
      tempDiv.style.position = 'absolute';
      tempDiv.style.visibility = 'hidden';
      document.body.appendChild(tempDiv);
      const computedColor = window.getComputedStyle(tempDiv).backgroundColor;
      document.body.removeChild(tempDiv);
      
      const rgbMatch = computedColor.match(/\d+/g);
      if (rgbMatch && rgbMatch.length >= 3) {
        const r = parseInt(rgbMatch[0]);
        const g = parseInt(rgbMatch[1]);
        const b = parseInt(rgbMatch[2]);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        $button[0].style.color = luminance < 0.5 ? '#ffffff' : '#000000';
      }
    } else if (isSoldOut) {
      // Reset button color when sold out
      $button[0].style.backgroundColor = '';
      $button[0].style.color = '';
    }

if (isSoldOut) {
  $('.add-to-cart-text').hide();
  $('.sold-out-text').show();
} else {
  $('.add-to-cart-text').show().text('ADD TO CART');
  $('.sold-out-text').hide();
}
    if (variant_map[selectedColor]) {
      variant_map[selectedColor].forEach(variant => {
        if (!variant.stock) {
          const $sizeElement = $(`.selector-element.size[data-value="${variant.name}"]`);
          $sizeElement
            .addClass('soldout')
            .removeClass('available')
            .find('.crossed-out').show();
          
          // Restore the original label text
          const labelText = $sizeElement.data('size-label');
          if (labelText) {
            $sizeElement.find('label').html(
              labelText + 
              '<img class="crossed-out" src="' + window.productData.assetUrl + '/soldout1.png" />'
            );
          }
        }
      });
    }
    
    updateVariantSelection();
  }).click(function() {
    updateImages($(this).val());
  });
  
  
      // Size selection handler
      $('input[name="option-1"]').change(function() {
        updateVariantSelection();
      });
    } else {
      // Single variant handlers
      if (first_option === 'Color') {
        $('input[name="option-0"]').change(function() {
          let selectedValue = $(this).val();
          updateImages(selectedValue);
          updateVariantSelection();
        }).click(function() {
          updateImages($(this).val());
        });
      } else {
        $('input[name="option-1"]').change(function() {
          updateVariantSelection();
        });
      }
    }
  // URL variant handling
  let searchParams = new URLSearchParams(window.location.search);
  let variantParam = searchParams.get('variant');
  
  if (variantParam) {
    let foundVariant = all_variants.find(v => v.id === Number(variantParam));
    if (foundVariant) {
      console.log('URL Variant found:', foundVariant);
      if (variant_count == 2) {
        $('.swatch-element[data-value="' + foundVariant.option1 + '"]').find('input').click();
        $(`.selector-element.size[data-value="${foundVariant.option2}"]`).find('input').click();
      } else {
        if (first_option === 'Color') {
          $('.swatch-element[data-value="' + foundVariant.option1 + '"]').find('input').click();
        } else {
          $(`.selector-element.size[data-value="${foundVariant.option1}"]`).find('input').click();
        }
      }
    }
  }

// Add to cart handler
$('#AddToCartForm').on('submit', function(e) {
    e.preventDefault();
    
    let selectedVariant;
    if (variant_count == 2) {
      const selectedColor = $('input[name="option-0"]:checked').val();
      const selectedSize = $('input[name="option-1"]:checked').val();
      
      if (!selectedColor || !selectedSize) {
        console.log('Missing selection:', { color: selectedColor, size: selectedSize });
        return;
      }

      selectedVariant = variant_map[selectedColor].find(v => 
        v.name === selectedSize && v.stock
      );
    } else {
      // Single variant handling
      if (first_option === 'Color') {
        const selectedValue = $('input[name="option-0"]:checked').val();
        if (!selectedValue) {
          console.log('No color selected');
          return;
        }
        selectedVariant = variant_map[selectedValue][0];
      } else {
        // Size-only variant
        const selectedValue = $('input[name="option-1"]:checked').val();
        if (!selectedValue) {
          console.log('No size selected');
          return;
        }
        // For size-only variants, find directly in all_variants
        const variant = all_variants.find(v => v.option1 === selectedValue);
        if (variant) {
          selectedVariant = {
            id: variant.id,
            stock: variant.available
          };
          $('#productSelect').val(variant.id);
        }
      }
    }

    if (!selectedVariant || !selectedVariant.stock || $('#AddToCart').prop('disabled')) {
      console.log('Add to cart blocked - variant not selected or unavailable');
      return;
    }

    console.log('Adding to cart:', {
      form: $('form[action$="/cart/add"]').serialize(),
      selectedVariant: $('#productSelect').val()
    });
          
    $.ajax({
      type: 'POST',
      url: window.Shopify.routes.root + 'cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function(addResponse) {
        // Get updated cart data to get the new total count
        $.ajax({
          type: 'GET',
          url: window.Shopify.routes.root + 'cart.js',
          dataType: 'json',
          success: function(cartData) {
            // Update cart count with the new total
            if ($('#cart-count').length > 0) {
              $('#cart-count').html(cartData.item_count);
            } else {
              $('#cart-icon').after('<span id="cart-count">' + cartData.item_count + '</span>');
            }
            
            // Then fetch fresh cart data and open drawer
            fetch('?section_id=cart-drawer')
              .then(response => response.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newCartContent = doc.querySelector('.cart-container');
                
                if (newCartContent) {
                  const cartDrawer = document.getElementById('cart-drawer');
                  const currentContainer = cartDrawer.querySelector('.cart-container');
                  if (currentContainer) {
                    currentContainer.innerHTML = newCartContent.innerHTML;
                  }
                  toggleCart();
                }
              })
              .catch(error => console.error('Error updating cart:', error));
          }
        });
      },
      error: function(XMLHttpRequest, textStatus) {
        console.error('Cart add failed:', XMLHttpRequest, textStatus);
      }
  });
  });


// Image update function
function updateImages(selectedValue) {
    if (first_option === 'Color') {
        console.log('1. Starting updateImages with color:', selectedValue);
        
        if (!selectedValue || !variant_map[selectedValue]) {
            console.error('Error: Invalid color or variant map');
            return;
        }
        
        // Build media array
        let mediaItems = [];
        if (variant_count == 2) {
            const mainVariant = variant_map[selectedValue][0];
            mediaItems = [{
                type: 'image',
                src: mainVariant.image,
                sequenceNum: 0
            }];
        } else {
            // Single variant - use same structure as two variants
            const mainVariant = variant_map[selectedValue][0];
            mediaItems = [{
                type: 'image',
                src: mainVariant.image,
                sequenceNum: 0
            }];
        }

        // Add additional media from metafields
        if (selectedValue in variable_image_mapping) {
            mediaItems = mediaItems.concat(
                variable_image_mapping[selectedValue].map(item => ({
                    type: item.type,
                    src: item.src,
                    sequenceNum: item.sequenceNum + 1
                }))
            );
        }

        mediaItems.sort((a, b) => a.sequenceNum - b.sequenceNum);
        
        const galleryContainer = document.querySelector('.pswp-gallery__container');
        const desktopGallery = document.querySelector('.product-gallery-desktop');
        
        if (!galleryContainer) return;

        // Create temporary container for new content
        const tempContainer = document.createElement('div');
        const tempDesktopContainer = document.createElement('div');

        // Preload all images before updating the DOM
        Promise.all(mediaItems.map(item => {
            if (item.type === 'image') {
                return new Promise((resolve, reject) => {
                    const displaySrc = item.src.replace('1600x', '640x');
                    const img = new Image();
                    img.onload = resolve;
                    img.onerror = resolve;
                    img.src = displaySrc;
                });
            }
            return Promise.resolve();
        })).then(() => {
            try {
                // Destroy existing PhotoSwipe instances
                if (lightbox) {
                    lightbox.destroy();
                    lightbox = null;
                }
                if (window.desktopLightbox) {
                    window.desktopLightbox.destroy();
                    window.desktopLightbox = null;
                }

                // Create new gallery HTML with smaller images
                const galleryHTML = mediaItems.map((item, index) => {
                    const isVideo = item.type === 'video';
                    const displaySrc = item.src.replace('1600x', '640x');
                    return `
                        <a href="${item.src}" 
                           data-pswp-width="1600"
                           data-pswp-height="1600"
                           data-pswp-type="${item.type}"
                           class="pswp-gallery__item">
                            ${isVideo ? `
                                <video src="${item.src}" 
                                       class="product-video" 
                                       loading="${index === 0 ? 'eager' : 'lazy'}"
                                       style="width: 100%; height: 100%; object-fit: contain;"
                                       muted autoplay loop playsinline preload="auto">
                                    <source src="${item.src}" type="video/mp4">
                                </video>
                            ` : `
                                <img src="${displaySrc}" 
                                     class="product-image" 
                                     alt="${selectedValue} - Image ${index + 1}" 
                                     loading="${index === 0 ? 'eager' : 'lazy'}"
                                     style="width: 100%; height: 100%; object-fit: contain;">
                            `}
                        </a>
                    `;
                }).join('');

                // Update mobile gallery
                galleryContainer.innerHTML = galleryHTML;
                galleryContainer.scrollLeft = 0;

                // Update desktop gallery if it exists
                if (desktopGallery) {
                    const desktopGridHTML = mediaItems.map((item, index) => {
                        const isVideo = item.type === 'video';
                        const displaySrc = item.src.replace('1600x', '640x');
                        return `
                            <div class="desktop-image-container">
                                <a href="${item.src}" 
                                   data-pswp-width="1600"
                                   data-pswp-height="1600"
                                   data-pswp-type="${item.type}"
                                   class="pswp-gallery__item">
                                    ${isVideo ? `
                                        <video src="${item.src}" 
                                               class="product-image-desktop ${index === 0 ? 'active' : ''}"
                                               autoplay
                                               loop
                                               muted
                                               playsinline
                                               preload="auto"
                                               loading="${index === 0 ? 'eager' : 'lazy'}"
                                               style="cursor: zoom-in; width: 100%; height: 100%; object-fit: contain;">
                                            <source src="${item.src}" type="video/mp4">
                                        </video>
                                    ` : `
                                        <img src="${displaySrc}" 
                                             alt="${selectedValue} - Image ${index + 1}" 
                                             class="product-image-desktop ${index === 0 ? 'active' : ''}" 
                                             loading="${index === 0 ? 'eager' : 'lazy'}"
                                             style="cursor: zoom-in">
                                    `}
                                </a>
                            </div>
                        `;
                    }).join('');

                    const saleBadge = desktopGallery.querySelector('.product-on-sale');
                    desktopGallery.innerHTML = `
                        ${saleBadge ? saleBadge.outerHTML : ''}
                        <div class="desktop-images-grid pswp-gallery">
                            ${desktopGridHTML}
                        </div>
                    `;
                }

                // Initialize videos after DOM update
                document.querySelectorAll('video').forEach(video => {
                    video.play().catch(err => console.log('Video autoplay failed:', err));
                });
  
        // Initialize PhotoSwipe with video support
        const pswpOptions = {
          ...lightboxOptions,
          gallery: '.pswp-gallery__container',
          children: '.pswp-gallery__item',
          pswpModule: PhotoSwipe
        };

        lightbox = new PhotoSwipeLightbox(pswpOptions);
        
        // Handle video in PhotoSwipe
        lightbox.on('contentLoad', (e) => {
          const { content } = e;
          if (content.data.type === 'video') {
            content.element = document.createElement('video');
            content.element.src = content.data.src;
            content.element.controls = true;
            content.element.autoplay = true;
            content.element.loop = true;
            content.element.muted = true;
            content.element.playsinline = true;
          }
        });

        lightbox.init();
  
        // Initialize desktop gallery separately
        const desktopGalleryElement = document.querySelector('.product-gallery-desktop .pswp-gallery');
        if (desktopGalleryElement) {
          window.desktopLightbox = new PhotoSwipeLightbox({
            ...pswpOptions,
            gallery: '.product-gallery-desktop .pswp-gallery',
            children: '.pswp-gallery__item'
          });
          window.desktopLightbox.init();
        }
  
        // Add click handlers
        document.querySelectorAll('.pswp-gallery__item').forEach((item, index) => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            const isDesktop = item.closest('.product-gallery-desktop');
            const instance = isDesktop ? window.desktopLightbox : lightbox;
            instance.loadAndOpen(index);
          });
        });
  
       } catch (error) {
                console.error('Error updating gallery:', error);
            }
        });
    }
}
});

// Meta Pixel PageView fix
(function() {
  let fbPageViewFired = false;
  let fbqRetryCount = 0;
  const MAX_RETRIES = 5;

  function tryFirePageView() {
      if (fbPageViewFired) return;
      
      if (typeof fbq === 'function') {
          fbq('track', 'PageView');
          fbPageViewFired = true;
          console.log('[Meta] Initial PageView sent once');
      } else if (fbqRetryCount < MAX_RETRIES) {
          fbqRetryCount++;
          console.log(`[Meta] fbq not ready, retry ${fbqRetryCount} of ${MAX_RETRIES}`);
          setTimeout(tryFirePageView, 1000);
      } else {
          console.log('[Meta] Failed to fire PageView after max retries');
      }
  }

  // Wait for everything else to load first
  window.addEventListener('load', function() {
      setTimeout(tryFirePageView, 1500);
  });
})
();
